// @ts-strict-ignore
import {Component, Input, OnChanges, SimpleChanges, ViewChild, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {SimUser} from "@models";
import {SimMaterialDialogService, SimUserService} from "@services";
import {Translations} from "@translations";
import {SimBaseChipInputComponent, VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-user-chip-input",
	templateUrl: "./sim-user-chip-input.component.html",
	styleUrls: ["./sim-user-chip-input.component.scss"],
	standalone: false,
})
export class SimUserChipInputComponent implements OnChanges {
	T = Translations;

	@ViewChild("simUserSimBaseChipInputComponent")
	simUserSimBaseChipInputComponent: SimBaseChipInputComponent<SimUser>;

	@Input() userFc: FormArray<FormControl<SimUser>>;
	@Input() excludedUsers: SimUser[] = [];

	@Input() placeholder: string;
	@Input() label: string;

	@Input() hasNewUserOption: boolean = false;

	@Input() canSelectMultipleUsers: boolean = false;
	@Input() isAutofocusEnabled: boolean = true;

	optionSelected = output<SimUser>();

	@ViewChild(SimBaseChipInputComponent)
	baseInput: SimBaseChipInputComponent<SimUser>;

	autoCompleteData: VMAutoCompleteNormal<SimUser>[] = [];

	constructor(
		private _simUserService: SimUserService,
		private _dialogService: SimMaterialDialogService,
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["excludedUsers"] && !changes["excludedUsers"].firstChange) {
			this.reloadAutoCompleteData(this.simUserSimBaseChipInputComponent?.searchControl?.value);
		}
	}

	async reloadAutoCompleteData(searchString: string) {
		let users = await this._simUserService.listUsers(searchString, "Username", true, 0, 20);

		this.autoCompleteData = users.data
			.filter((u) => !this.excludedUsers.some((excludedUser) => excludedUser?.id === u.id))
			.map((u) => ({
				displayName: this.displayUser(u),
				value: u,
			}));
	}

	displayUser(user: SimUser) {
		return `${user?.firstname} ${user?.lastname}`;
	}

	createNewUser() {
		let dialogRef = this._dialogService.openAddAdHocUserDialog({});

		dialogRef.then((output) => {
			if (output.action === "ok") {
				this.baseInput.autoCompleteOptionSelected({
					value: output.user,
					displayName: output.user.firstname + " " + output.user.lastname,
				});
			}
		});
	}

	openUserCardDialog(event: SimUser) {
		this._dialogService.openUserCardMatDialog({userData: event});
	}
}
